import React from 'react';
import { Input, Form } from 'antd';

export class HubSpotExclusionField extends React.Component {

  render(): JSX.Element {
    // The purpose of this hidden field is to prevent HubSpot from tracking submissions of the form where this field is present.
    // It acts as a flag to distinguish the form from others that should be tracked by HubSpot. It must be
    // rendered inside an antd Form component
    return (
      <Form.Item style={{ display: 'none' }} name="amex">
        <Input />
      </Form.Item>
    );
  }
}